import { Component, inject, input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { TripService } from '../../services/trip.service';
import { ValidationTranslatorService } from '../../services/validation-translator.service';

@Component({
  selector: 'app-trip-validation-badge',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './trip-validation-badge.component.html'
})
export class TripValidationBadgeComponent {
  private tripService = inject(TripService);
  private validationTranslator = inject(ValidationTranslatorService);

  // Inputs
  tooltipPosition = input<'top' | 'bottom' | 'left' | 'right'>('bottom');
  clickAction = input<() => void>();

  get hasValidationIssues(): boolean {
    const report = this.tripService.validationReport();
    return report ? report.errors > 0 || report.warnings > 0 : false;
  }

  get validationSummary(): string {
    const report = this.tripService.validationReport();
    if (!report) return '';
    return this.validationTranslator.getSummary(report.issues);
  }

  get detailedValidationText(): string {
    const report = this.tripService.validationReport();
    if (!report || report.issues.length === 0) return '';

    const messages = report.issues.map(issue =>
      `- ${this.validationTranslator.translateIssue(issue)}`
    );
    return messages.join('\n');
  }

  handleClick(): void {
    const action = this.clickAction();
    if (action) {
      action();
    }
  }
}
